import { render, staticRenderFns } from "./SalesOrders.vue?vue&type=template&id=58e58596&scoped=true&"
import script from "./SalesOrders.vue?vue&type=script&lang=ts&"
export * from "./SalesOrders.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrders.vue?vue&type=style&index=0&id=58e58596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e58596",
  null
  
)

export default component.exports